import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesImprimirHistoricoMaisBrasil.vue?vue&type=template&id=b298159c"
import script from "./LicitacaoAtualizacaoAcoesImprimirHistoricoMaisBrasil.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesImprimirHistoricoMaisBrasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports